import { Globe } from '@brandfolder/icons';
import React, { FunctionComponent } from 'react';

const iconStyle: React.CSSProperties = {
  display: 'inline-block',
  lineHeight: 1,
  verticalAlign: 'middle',
  width: '18px',
  height: '18px',
  padding: '0px',
};

export const GlobeIcon: FunctionComponent = () => (
  <Globe height={18} style={iconStyle} width={18} />
);
